export default __webpack_public_path__ + "static/media/loginbg44.06eafe68.jpg";